import { useCallback, useEffect, useState } from 'react'
import { Card, Col, Form, Row } from 'react-bootstrap'
import MenuItem from '@mui/material/MenuItem'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/treatment-plans/treatment-plan-types/style'
import 'features/setting/treatment-plans/treatment-plan-types/style.css'

/** API */
import TreatmentPlanTypeApi from 'api/setting/treatment-plans/treatment-plan-type.api'

/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'

/** COMPONENT */
import { swalActive } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputTextField from 'component/Input/InputTextField'
import InputTextSearch from 'component/Input/InputTextSearch'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import TableCustom from 'component/Table/TableCustom'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import FilterSelect from 'component/Select/FilterSelect'
import TableRowExport from 'component/Pdf/TableRowExport'
import ButtonExport from 'component/Button/ButtonExport'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import { Box, Typography } from '@mui/material'
import SwitchButton from 'new-components/buttons/switch-button'
import TextInput from 'new-components/inputs/text-input'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const initStateErrorMessage = {
  TREATMENT_PLAN_TYPE_NAME: ``,
  IS_DUPLICATE_TREATMENT_PLAN_TYPE_NAME: ``,
  TREATMENT_PLAN_TYPE_NAME_STRING_BASE: ``,
  TREATMENT_PLAN_TYPE_NAME_STRING_EMPTY: ``,
  TREATMENT_PLAN_TYPE_NAME_MAXIMUM_LENGTH: ``,
  TREATMENT_PLAN_TYPE_NAME_ANY_REQUIRED: ``,

  TREATMENT_PLAN_TYPE_NAME_EN: ``,
  IS_DUPLICATE_TREATMENT_PLAN_TYPE_NAME_EN: ``,
  TREATMENT_PLAN_TYPE_NAME_EN_STRING_BASE: ``,
  TREATMENT_PLAN_TYPE_NAME_EN_STRING_EMPTY: ``,
  TREATMENT_PLAN_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
  TREATMENT_PLAN_TYPE_NAME_EN_ANY_REQUIRED: ``
}
export default function TreatmentPlanTypes() {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [treatmentPlanTypes, setTreatmentPlanTypes] = useState([])
  const [exportData, setExportData] = useState([])

  const [treatmentPlanTypeId, setTreatmentPlanTypeId] = useState(Number)
  const [treatmentPlanTypeName, setTreatmentPlanTypeName] = useState('')
  const [treatmentPlanTypeNameEn, setTreatmentPlanTypeNameEn] = useState('')
  const [treatmentPlanTypeStatus, setTreatmentPlanTypeStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  const [isAlertDel, setIsAlertDel] = useState<number>(0)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isOpen, setIsOpen] = useState(false)

  const loadData = useCallback(async () => {
    let condition: any = {}
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

    const res = await TreatmentPlanTypeApi.findAll(condition)
    if (res.status === 200) {
      setRowCount(res.headers['x-total'])
      setTreatmentPlanTypes(res.data)
    }
  }, [page, pageLimit, search, sortBy, sortType, status])

  useEffect(() => {
    loadData()
  }, [loadData])

  const loadDataForExport = useCallback(async () => {
    let condition: any = {}
    condition.export = 1
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }

    const res = await TreatmentPlanTypeApi.findAll(condition)
    if (res.status === 200) {
      setExportData(res.data)
    }
  }, [page, pageLimit, search, sortBy, sortType, status])

  useEffect(() => {
    loadDataForExport()
  }, [loadDataForExport])

  const submit = () => {
    if (!treatmentPlanTypeName) return setErrorMessage({ ...errorMessage, ...{ TREATMENT_PLAN_TYPE_NAME: t('TREATMENT_PLAN_TYPE.MESSAGE.TREATMENT_PLAN_TYPE_NAME') } })

    dispatch(submitModal())
    TreatmentPlanTypeApi.create({ treatmentPlanTypeName, treatmentPlanTypeNameEn })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('TREATMENT_PLAN_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()

          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_PLAN_TYPE.MESSAGE.${err.message}`) } })
          setIsOpen(false)
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_PLAN_TYPE.MESSAGE.${err.message}`) } })
        setIsOpen(false)
      })
  }

  const submitEdit = () => {
    if (!treatmentPlanTypeName) return setErrorMessage({ ...errorMessage, ...{ TREATMENT_PLAN_TYPE_NAME: t(`TREATMENT_PLAN_TYPE.MESSAGE.TREATMENT_PLAN_TYPE_NAME`) } })

    dispatch(submitModal())
    TreatmentPlanTypeApi.update(treatmentPlanTypeId, {
      treatmentPlanTypeName,
      treatmentPlanTypeNameEn,
      status: treatmentPlanTypeStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`TREATMENT_PLAN_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          setIsOpen(false)
        } else {
          const err = res.response.data

          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_PLAN_TYPE.MESSAGE.${err.message}`) } })
          setIsOpen(false)
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_PLAN_TYPE.MESSAGE.${err.message}`) } })
        setIsOpen(false)
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setTreatmentPlanTypeId(0)
    setTreatmentPlanTypeName('')
    setTreatmentPlanTypeNameEn('')
    setTreatmentPlanTypeStatus('')
    clearErrorMessage()
    setIsOpen(false)
  }

  const onActive = () => {
    if (id) {
      TreatmentPlanTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TREATMENT_PLAN_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TREATMENT_PLAN_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = async () => {
    if (id) {
      TreatmentPlanTypeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TREATMENT_PLAN_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TREATMENT_PLAN_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { treatmentPlanTypeId: txPlanTypeId, treatmentPlanTypeName: txPlanTypeName, treatmentPlanTypeNameEn: txPlanTypeNameEn, status: txPlanTypeStatus } = data
    setTreatmentPlanTypeId(txPlanTypeId)
    setTreatmentPlanTypeName(txPlanTypeName)
    setTreatmentPlanTypeNameEn(txPlanTypeNameEn)
    setTreatmentPlanTypeStatus(txPlanTypeStatus)
    setIsOpen(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'treatmentPlanTypeName', disablePadding: false, label: t('TREATMENT_PLAN_TYPE.TABLE.CELL.TREATMENT_PLAN_TYPE_NAME') },
    { id: 'treatmentPlanTypeNameEn', disablePadding: false, label: t('TREATMENT_PLAN_TYPE.TABLE.CELL.TREATMENT_PLAN_TYPE_NAME_EN') },
    { id: 'status', disablePadding: false, label: t('TREATMENT_PLAN_TYPE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('TREATMENT_PLAN_TYPE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number, valueExportData: boolean) => {
    const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
    const { treatmentPlanTypeId: txPlanTypeId, treatmentPlanTypeName: txPlanTypeName, treatmentPlanTypeNameEn: txPlanTypeNameEn, updatedBy, updatedAt, status: txPlanTypeStatus } = objData
    const statusBtnActive = txPlanTypeStatus === 'ACTIVE' ? true : false
    const statusBtnInActive = txPlanTypeStatus === 'INACTIVE' ? true : false
    const objRenderData = {
      key: txPlanTypeId,
      id: txPlanTypeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: num },
        { option: 'TEXT', align: 'left', label: txPlanTypeName || "-" },
        { option: 'TEXT', align: 'left', label: txPlanTypeNameEn || "-" },
        { option: 'STATUS', align: 'center', label: txPlanTypeStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: false },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: false }
          ]
        }
      ]
    }
    return (
      <>
        {valueExportData === true && <TableRowExport {...objRenderData} /> ||
          <TableRowCommon
            {...objRenderData}
            onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
            oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
            onedit={() => onEdit(objRenderData.obj)}
            ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
          />
        }
      </>
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.treatmentPlanTypeName)
    setNameEn(obj.treatmentPlanTypeNameEn)
  }

  const filter = [
    { label: `${t('INPUT.SEARCH')}: ${search || '-'}` },
    { label: `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}` }
  ]

  return (
    <div className={classes.root}>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`TREATMENT_PLAN_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`TREATMENT_PLAN_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { treatmentPlanTypeName: name, treatmentPlanTypeNameEn: nameEn && `(${nameEn})`, status: t(`TREATMENT_PLAN_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <Card className="border-0 h-100">
        <HeaderCard text={t('TREATMENT_PLAN_TYPE.TITLE')} />
        <Card.Body>
          <Card.Title className={'mb-0 pl-xl-3'}>
            <Row className="align-items-center">
              <Col md={6} lg={7}>
                <Row className="flax-row">
                  <Col sm={12} md={6} xl={4} className="pt-2">
                    <InputTextSearch
                      keyInput={'search'}
                      label={t('TREATMENT_PLAN_TYPE.SEARCH')}
                      value={search}
                      onchange={(event) => {
                        setSearch(event.target.value)
                        setPage(1)
                      }}
                      onClear={(event) => {
                        setSearch('')
                        setPage(1)
                      }}
                    />
                  </Col>
                  <Col sm={12} md={6} xl={4} className="pl-md-0 pt-2">
                    <FilterSelect
                      onchange={(event) => {
                        const value = event.target.value
                        if (value) {
                          handleChangeStatus(value)
                          setPage(1)
                        }
                      }}
                      renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                      label={t('STATUS.LABEL')}
                      selectId="select-status"
                      value={status}
                      labelId="label-status"
                      options={[
                        <MenuItem key="1" value="ALL">
                          {t('STATUS.ALL')}
                        </MenuItem>,
                        <MenuItem key="2" value="ACTIVE">
                          {t('STATUS.ACTIVE')}
                        </MenuItem>,
                        <MenuItem key="3" value="INACTIVE">
                          {t('STATUS.INACTIVE')}
                        </MenuItem>
                      ]}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={6} lg={5} className="mt-2 mt-md-auto">
                <div className="pr-xl-2 d-flex">
                  <div className='ml-auto'>
                    <ButtonExport headCells={headCells} portrait={true} filter={filter} fileName={t('TREATMENT_PLAN_TYPE.INPUT.TREATMENT_PLAN_TYPE_NAME')}
                      rowsData={exportData.map((val, i) => {
                        return renderData(val, i, true)
                      })} />
                  </div>
                  <div className='pl-3'>
                    <ButtonCustom mode="add" onClick={() => setIsOpen(true)} textButton={t('TREATMENT_PLAN_TYPE.BUTTON.ADD')} className="w-auto ml-auto d-flex mt-auto" btnStyle={{ height: '44px' }} />
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Title>

          <div className={'mt-3 pl-xl-3 pr-xl-2'}>
            <TableCustom
              page={page}
              pageLimit={pageLimit}
              sortType={sortType}
              sortBy={sortBy}
              onSort={onRequestSort}
              setPageLimit={handleChangeRowsPerPage}
              setPage={handleChangePage}
              rowCount={rowCount}
              headCells={headCells}
              rowsData={treatmentPlanTypes.map((val, i) => {
                return renderData(val, i, false)
              })}
            />
          </div>
        </Card.Body>
      </Card>
      <PageModal
        title={treatmentPlanTypeId ? t('TREATMENT_PLAN_TYPE.TITLE_UPDATE') : t('TREATMENT_PLAN_TYPE.TITLE_CREATE')}
        size='XS'
        isOpen={isOpen}
        handleClose={resetForm}
        onCancel={{ onClick: resetForm, title: t('TREATMENT_PLAN_TYPE.BUTTON.CANCEL') }}
        onSubmit={{ onClick: treatmentPlanTypeId ? submitEdit : submit, title: t('TREATMENT_PLAN_TYPE.BUTTON.SAVE') }}
      >
        <Box display="flex" flexDirection="column" gap="16px">
          {treatmentPlanTypeId ? <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
            <SwitchButton onChange={() => setTreatmentPlanTypeStatus(treatmentPlanTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={treatmentPlanTypeStatus === 'ACTIVE' ? true : false} />
          </Box> : ''}
          <TextInput
            onChange={(event) => {
              setTreatmentPlanTypeName(event.target.value)
              clearErrorMessage()
            }}
            value={treatmentPlanTypeName}
            label={t('TREATMENT_PLAN_TYPE.INPUT.TREATMENT_PLAN_TYPE_NAME')}
            helperText={
              errorMessage.TREATMENT_PLAN_TYPE_NAME ||
              errorMessage.IS_DUPLICATE_TREATMENT_PLAN_TYPE_NAME ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_STRING_BASE ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_STRING_EMPTY ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_MAXIMUM_LENGTH ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_ANY_REQUIRED
            }
            required
          />
          <TextInput
            onChange={(event) => {
              setTreatmentPlanTypeNameEn(event.target.value)
              clearErrorMessage()
            }}
            value={treatmentPlanTypeNameEn}
            helperText={
              errorMessage.TREATMENT_PLAN_TYPE_NAME_EN ||
              errorMessage.IS_DUPLICATE_TREATMENT_PLAN_TYPE_NAME_EN ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_STRING_BASE ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_STRING_EMPTY ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_MAXIMUM_LENGTH ||
              errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_ANY_REQUIRED
            }
            label={t('TREATMENT_PLAN_TYPE.INPUT.TREATMENT_PLAN_TYPE_NAME_EN')}
          />
        </Box>
      </PageModal>
      <ModalCustom
        title={treatmentPlanTypeId ? t('TREATMENT_PLAN_TYPE.TITLE_UPDATE') : t('TREATMENT_PLAN_TYPE.TITLE_CREATE')}
        modalStyle="modal-treatment-plan-types"
        component={
          <div className="pb-2">
            {treatmentPlanTypeId ? (
              <div>
                <Form className="mx-0 mt-0 mb-3 p-0  d-inline-flex w-100">
                  <Form.Label className=" mr-auto">{t('INPUT.LABEL_STATUS')}</Form.Label>
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    onChange={() => setTreatmentPlanTypeStatus(treatmentPlanTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                    checked={treatmentPlanTypeStatus === 'ACTIVE' ? true : false}
                    style={{ marginLeft: 'auto' }}
                  />
                </Form>
              </div>
            ) : (
              ''
            )}

            <InputTextField
              onchange={(event) => {
                setTreatmentPlanTypeName(event.target.value)
                clearErrorMessage()
              }}
              value={treatmentPlanTypeName}
              label={t('TREATMENT_PLAN_TYPE.INPUT.TREATMENT_PLAN_TYPE_NAME')}
              helperText={
                errorMessage.TREATMENT_PLAN_TYPE_NAME ||
                errorMessage.IS_DUPLICATE_TREATMENT_PLAN_TYPE_NAME ||
                errorMessage.TREATMENT_PLAN_TYPE_NAME_STRING_BASE ||
                errorMessage.TREATMENT_PLAN_TYPE_NAME_STRING_EMPTY ||
                errorMessage.TREATMENT_PLAN_TYPE_NAME_MAXIMUM_LENGTH ||
                errorMessage.TREATMENT_PLAN_TYPE_NAME_ANY_REQUIRED
              }
              required={true}
              style={{ marginBottom: '1rem' }}
            />
            <br />
            <InputTextField
              key="treatmentPlanTypeNameEn"
              onchange={(event) => {
                setTreatmentPlanTypeNameEn(event.target.value)
                clearErrorMessage()
              }}
              value={treatmentPlanTypeNameEn}
              helperText={
                errorMessage.TREATMENT_PLAN_TYPE_NAME_EN ||
                errorMessage.IS_DUPLICATE_TREATMENT_PLAN_TYPE_NAME_EN ||
                errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_STRING_BASE ||
                errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_STRING_EMPTY ||
                errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_MAXIMUM_LENGTH ||
                errorMessage.TREATMENT_PLAN_TYPE_NAME_EN_ANY_REQUIRED
              }
              label={t('TREATMENT_PLAN_TYPE.INPUT.TREATMENT_PLAN_TYPE_NAME_EN')}
              required={false}
            />
          </div>
        }
        onReset={resetForm}
        onSubmit={treatmentPlanTypeId ? submitEdit : submit}
        textBtnCancel={t('TREATMENT_PLAN_TYPE.BUTTON.CANCEL')}
        textBtnConfirm={t('TREATMENT_PLAN_TYPE.BUTTON.SAVE')}
      />
    </div>
  )
}
